import React from 'react'
import { Select, type SelectProps } from 'components/Select'
import { type State } from 'types/graphql-generated'
import { EMPTY_STATE_OPTION, STATE_OPTIONS } from './constants'

export const StateSearch: React.FC<React.PWC<SelectProps<State>>> = (props) => (
  <Select
    defaultValue={EMPTY_STATE_OPTION}
    options={STATE_OPTIONS}
    aria-label="state dropdown"
    {...props}
  />
)
